export default __webpack_public_path__ + "media/color/trx-af76acb3.svg";